import LinkedMemberList from '../../../../components/Main/Group/LinkedMember/LinkedMemberList'
import LinkedMemberModal from '../../../../components/Main/Group/LinkedMember/LinkedMemberModal'
import React from 'react'

function LinkedMember (props) {
  return (
    <div>
      <LinkedMemberModal {...props} />
      <LinkedMemberList {...props} />
    </div>
  )
}

export default LinkedMember
